import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useLang } from "@/contexts/LanguageContext";

export const ThemeChooser = () => {
  const { chooser, setTheme, dismissChooser } = useTheme();
  const { t } = useLang();
  if (!chooser) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6" data-testid="theme-chooser">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={dismissChooser} />
      <div className="relative vl-card rounded-2xl p-8 sm:p-10 max-w-md w-full text-center vl-fade-up">
        <div className="font-serif-display text-2xl sm:text-3xl text-[var(--vl-ivory)]">{t("theme_choose_title")}</div>
        <p className="text-sm text-[var(--vl-stone)] mt-3">{t("theme_choose_sub")}</p>
        <div className="grid grid-cols-2 gap-4 mt-8">
          <button onClick={() => setTheme("light")} className="rounded-xl border border-[var(--vl-border)] p-6 hover:border-[var(--vl-gold)] transition-colors group" data-testid="choose-light">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#FAF7F2] flex items-center justify-center mb-3">
              <Sun size={26} className="text-[#B8902B]" />
            </div>
            <div className="text-sm tracking-widest uppercase text-[var(--vl-ivory)]">{t("theme_light")}</div>
          </button>
          <button onClick={() => setTheme("dark")} className="rounded-xl border border-[var(--vl-border)] p-6 hover:border-[var(--vl-gold)] transition-colors group" data-testid="choose-dark">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#0D0C0A] flex items-center justify-center mb-3 border border-[var(--vl-border)]">
              <Moon size={26} className="text-[#D4AF37]" />
            </div>
            <div className="text-sm tracking-widest uppercase text-[var(--vl-ivory)]">{t("theme_dark")}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThemeChooser;
